// Collection ID constants used across HR and CMS collection pages

export const CENSUS_ID_1940 = '2000219'
export const CENSUS_ID_1950 = '4464515'
export const IGI_ID = '5'

// IGI-specific wiki link. The title is English-only, so the locale is pinned; without it the router
// prepends the viewer's locale and non-English wikis 404.
export const IGI_WIKI_LINK = '/en/wiki/International_Genealogical_Index_(IGI)_-_FamilySearch_Historical_Records'

// US Census collection IDs (1910–1950) — excluded from wiki-about embedding (search_cmsCollectionsUSCensus flag removed, FSS-14735)
export const US_CENSUS_CMS_COLLECTION_IDS = new Set([
  '1727033', // 1910
  '1488411', // 1920
  '1810731', // 1930
  '2000219', // 1940
  '4464515', // 1950
])
